import React from "react";
import { IconCamera } from "@tabler/icons-react";

type Props = {
    hasPhoto: boolean;
    onClick: () => void;
};

const VoterPhotoTrigger = ({ hasPhoto, onClick }: Props) => (
    <button
        type="button"
        onClick={onClick}
        title={hasPhoto ? "Retake Voter Photo" : "Capture Voter Photo"}
        aria-label={hasPhoto ? "Retake Voter Photo" : "Capture Voter Photo"}
        className={`flex h-11 w-11 items-center justify-center rounded-full border bg-white shadow-sm transition hover:bg-gray-50 ${
            hasPhoto ? "border-green-400 text-green-600" : "border-gray-300 text-gray-700"
        }`}
    >
        <IconCamera size={19} />
    </button>
);

export default VoterPhotoTrigger;
